import { IAPIResponse } from "@mindmemobile/mm-shared-global";
import { Observable } from "rxjs";
import { HttpService, url } from "../../shared/services";
import { IAPIPaymentSettingsModel, IAPIUpdateAccountSettingsModel } from "../../shared/interfaces";

class PaymentSettingsService {
  private httpService: HttpService;
  constructor() {
      this.httpService = new HttpService(
          undefined,
          `${process.env.REACT_APP_API_KEY}`,
          process.env.REACT_APP_API_BASE_URL,
      );
  }

  updateMerchantPaymentMethods(data: IAPIPaymentSettingsModel): Observable<IAPIResponse<IAPIPaymentSettingsModel>> {
      return this.httpService.put<IAPIResponse<IAPIPaymentSettingsModel>>(url.updateMerchantPaymentSettings, data);
  }

  updateSettings(data: IAPIUpdateAccountSettingsModel): Observable<IAPIResponse<boolean>> {
      return this.httpService.put<IAPIResponse<boolean>>(url.updateAccountSettings, data);
  }
}
export default new PaymentSettingsService();
